<template>
  <article>
    <v-header></v-header>
    <header-search :proshows="false" :licolors="title"></header-search>

    <template v-if="hotprodata.length==0 || marketdata.length==0 || businessdata.length==0  ">
      <div id="cart_empty">页面数据还在请求</div>
    </template>

    <template v-else>
      <div id="brandgiftbox">
        <div class="recommend">
          <div class="icon mt10"></div>
          <div class="mtitle">
            <span class="icon1"></span>&nbsp;员工福利推荐
          </div>
          <div class="recommendbt">
            <div class="recommendbtlf" v-show="hotprodata.length>0" @click="transferParameters(hotprodata[0].id)" >
              <img v-show="hotprodata[0].images.length>0" :src="hotprodata[0].images[0].url" />
              <div class="goods_title">{{hotprodata[0].title}}</div>
              <div class="goods_price">¥ {{hotprodata[0].price}}</div>
            </div>
            <div class="recommendbtrt">
              <div class="topic" v-for="(prodcet) in hotprodata.slice(1)" :key="prodcet.id" @click="transferParameters(prodcet.id)">
                <img v-show="prodcet.images.length>0" :src="prodcet.images[0].url" />
              </div>
            </div>
          </div>
        </div>
        <div class="recommend">
          <div class="icon mt10"></div>
          <div class="mtitle">
            <span class="icon1"></span>&nbsp;市场促销推荐
          </div>
          <div class="recommendbt">
            <div class="recommendbtlf" v-show="marketdata.length>0" @click="transferParameters(marketdata[0].id)">
              <img v-show="marketdata[0].images.length>0" :src="marketdata[0].images[0].url" />
              <div class="goods_title">{{marketdata[0].title}}</div>
              <div class="goods_price">¥ {{marketdata[0].price}}</div>
            </div>
            <div class="recommendbtrt">
              <div class="topic" v-for="(prodcet) in marketdata.slice(1)" :key="prodcet.id" @click="transferParameters(prodcet.id)">
                <img v-show="prodcet.images.length>0" :src="prodcet.images[0].url" />
              </div>
            </div>
          </div>
        </div>
        <div class="recommend">
          <div class="icon mt10"></div>
          <div class="mtitle">商务答谢推荐</div>
          <div class="recommendbt">
            <div class="recommendbtlf" v-show="businessdata.length>0" @click="transferParameters(businessdata[0].id)">
              <img v-show="businessdata[0].images.length>0" :src="businessdata[0].images[0].url" />
              <div class="goods_title">{{businessdata[0].title}}</div>
              <div class="goods_price">¥ {{businessdata[0].price}}</div>
            </div>
            <div class="recommendbtrt">
              <div class="topic" v-for="(prodcet) in businessdata.slice(1)" :key="prodcet.id" @click="transferParameters(prodcet.id)">
                <img :src="prodcet.images[0].url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <v-footer></v-footer>
  </article>
</template>
<script>
import footer from "./footer";
import header from "./header";
import headersearch from "./headersearch";
export default {
  components: {
    "v-footer": footer,
    "v-header": header,
    "header-search": headersearch
  },
  data() {
    return {
      title: "品牌礼品",
      hotprodata: [],
      marketdata: [],
      businessdata: []
    };
  },
  created() {
    this.rqhotprodata();
  },
  methods: {
    rqhotprodata() {
      this.$http.getTagProduct({ limit: 7, page: 1, kind: 1 }).then(res => {
        if (res.code == 200) {
          this.hotprodata = res.data;
          console.log(this.hotprodata);
        } else {
          console.log(res.msg);
        }
      });
      this.$http.getTagProduct({ limit: 7, page: 1, kind: 2 }).then(res => {
        if (res.code == 200) {
          this.marketdata = res.data;
          console.log(this.hotprodata);
        } else {
          console.log(res.msg);
        }
      });
      this.$http.getTagProduct({ limit: 7, page: 1, kind: 3 }).then(res => {
        if (res.code == 200) {
          this.businessdata = res.data;
          console.log(this.hotprodata);
        } else {
          console.log(res.msg);
        }
      });
    },
    transferParameters(id) {
      this.$router.push({
        path: "detail",
        query: {
          detail:id
          //通过query 传递参数
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#cart_empty {
  /* position: absolute;*/
  width: 1200px;
  height: 500px;
  line-height: 40px;
  margin: 0 auto;
  padding-top: 200px;
  text-align: center;
}

#brandgiftbox {
  width: 1200px;
  margin: 0 auto;
  .recommend {
    // border: 1px dashed orange;
    .mt10 {
      // margin-top: 24px;
    }
    .mtitle {
      margin-top: 24px;
      width: 100%;
      // margin-left: 12px;
      display: inline-block;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      vertical-align: middle;
      text-align: left;
      // border: 1px dashed orangered;
      .icon1 {
        width: 3px;
        height: 15px;
        background-color: red;
        display: inline-block;
      }
    }
    .recommendbt {
      margin-top: 16px;
      // border: 1px dashed red;
      .recommendbtlf {
        float: left;
        width: 432px;
        height: 496px;
        background: rgba(255, 255, 255, 1);
      }
      .recommendbtlf img {
        width: 416px;
        height: 416px;
        margin: 8px;
      }
      .goods_title {
        width: 416px;
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin: 0px 8px;
        text-align: left;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      .goods_price {
        width: 416px;
        height: 22px;
        line-height: 22px;
        margin: 6px 8px;
        font-family: HelveticaNeue-Bold;
        font-size: 16px;
        color: #e7001e;
        line-height: 22px;
        text-align: left;
        // border: 1px dashed red;
      }

      .recommendbtrt {
        float: left;
        width: 768px;
        height: 496px;
        .topic {
          margin: 0 0px 15px 16px;
          float: left;
          width: 240px;
          height: 240px;
          background: rgba(255, 255, 255, 1);
        }
      }
      .recommendbtrt img {
        width: 224px;
        height: 224px;
        margin: 8px;
      }
    }
  }
}
</style>
